import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ServiceBase} from './service-base';
import {ApplicationBase} from '../data-objects/application-base';
import {AddressViewmodel} from '../viewmodels/address-viewmodel';
import {AppHistoryDetails} from '../../../server/models/app-history-details';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {TermsConditionsData} from '../data-objects/terms-conditions-data';
import {PaymentData} from '../data-objects/payment-data';
import {UploadfilesViewmodel} from '../viewmodels/uploadfiles-viewmodel';
import {WorkrequestPfiViewmodel} from '../../create-application/pfi-form/workrequest-pfi-viewmodel';
import {WorkrequestViewmodelBase} from '../viewmodels/workrequest-viewmodel-base';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class ApplicationServiceBase<T extends ApplicationBase> extends ServiceBase {
  termsConditionsData: TermsConditionsData;
  uploadfilesViewmodel: UploadfilesViewmodel;
  paymentData: PaymentData;
  submitErrorMessage: string;
  applicationData: T;
  applicationDate: string;
  addressViewModel: AddressViewmodel;
  activeIndex: number;
  workRequestViewModel: WorkrequestViewmodelBase;
  serverError:BehaviorSubject<string>;

  public static get getUrl(): string {
    return ServiceBase.baseHref + '/api/getSpaApplications';
  }

  public static get checkStatusUrl(): string {
    return ServiceBase.baseHref + '/api/checkApplicationStatus';
  }

  public static get getUnallocatedApplicationsUrl(): string {
    return ServiceBase.baseHref + '/api/getUnallocatedApplications';
  }

  public static get getPaymentPendingApplicationsUrl(): string {
    return ServiceBase.baseHref + '/api/getPaymentPendingApplications';
  }

  public static get getOfficersUrl(): string {
    return ServiceBase.baseHref + '/api/getTaskAllocationOfficers';
  }

  public static get allocateToOfficerUrl(): string {
    return ServiceBase.baseHref + '/api/allocateTask';
  }

  public static get generatePaymentLinkUrl(): string {
    return ServiceBase.baseHref + '/api/generatePaymentLink';
  }

  // Inject HttpClient into your component or service.
  constructor(protected http: HttpClient) {
    super();
    this.paymentData = new PaymentData();
    this.serverError= new BehaviorSubject('')
  }

  protected get submitUrl(): string {
    return '';
  }

  get agreedToTsAndCs(): boolean {
    return this.termsConditionsData.agreedToTsAndCs;
  }

  set agreedToTsAndCs(v: boolean) {
    this.termsConditionsData.agreedToTsAndCs = v;
  }

  get authorisationTsAndCs(): boolean {
    return this.termsConditionsData.authorisationTsAndCs;
  }

  set authorisationTsAndCs(v: boolean) {
    this.termsConditionsData.authorisationTsAndCs = v;
  }

  initializeData(): void {
    this.submitErrorMessage = null;
    this.addressViewModel = new AddressViewmodel();
    this.applicationDate = new Date().toLocaleDateString('en-AU');
    this.activeIndex = 0;
    this.termsConditionsData = new TermsConditionsData();
    this.paymentData = new PaymentData();
    this.uploadfilesViewmodel = new UploadfilesViewmodel();
  }

  public submit(applicationDetails: ApplicationBase, token: string): Observable<string> {
    return this.submitImp(this.submitUrl, applicationDetails, token);
  }

  protected submitImp(submitUrl: string, applicationDetails: ApplicationBase, token: string): Observable<string> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
     
      let cleanApplicationDetails: ApplicationBase
      if(applicationDetails.applicationType ==="SRAGF" || applicationDetails.applicationType === "SRABF" ){

    
        cleanApplicationDetails = applicationDetails
        //cleanApplicationDetails = ServiceBase.sanitize(applicationDetails);
     }
     else{
      cleanApplicationDetails = ServiceBase.sanitize(applicationDetails);
     }
    return this.http.post<string>(submitUrl, JSON.stringify(cleanApplicationDetails), {headers: header});
  }

  get(accountNumber: string, token: string): Observable<AppHistoryDetails[]> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    if (accountNumber) {
      const params: HttpParams = new HttpParams().set('accountNumber', accountNumber);
      return this.http.get<AppHistoryDetails[]>(ApplicationServiceBase.getUrl, {headers: header, params: params});
    } else {
      return this.http.get<AppHistoryDetails[]>(ApplicationServiceBase.getUrl, {headers: header});
    }
  }

  checkStatus(token: string, DAMSApplicationId: string, paymentRefNum: string): Observable<AppHistoryDetails> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    const params: HttpParams = new HttpParams().set('DAMSApplicationId', DAMSApplicationId).append('paymentRefNum', paymentRefNum);
    return this.http.get<AppHistoryDetails>(ApplicationServiceBase.checkStatusUrl, {headers: header, params: params});
  }


  getUnallocated(token: string): Observable<AppHistoryDetails[]> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    return this.http.get<AppHistoryDetails[]>(ApplicationServiceBase.getUnallocatedApplicationsUrl, {headers: header});
  }

  getPaymentPending(token: string): Observable<AppHistoryDetails[]> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);
    return this.http.get<AppHistoryDetails[]>(ApplicationServiceBase.getPaymentPendingApplicationsUrl, {headers: header});
  }

  getOfficers(token: string): Observable<string[]> {
    const header: HttpHeaders = new HttpHeaders().append('Authorization', 'Bearer ' + token);
    return this.http.get<string[]>(ApplicationServiceBase.getOfficersUrl, {headers: header});
  }

  allocateApplication(damsApplicationID: string, officer: string, token: string): Observable<boolean> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);

    return this.http.put<boolean>(ApplicationServiceBase.allocateToOfficerUrl,
      JSON.stringify({damsApplicationID: damsApplicationID, officer: officer}), {headers: header});
  }

  generatePaymentLink(damsApplicationID: string, eMail: string, token: string): Observable<boolean> {
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);

    return this.http.put<boolean>(ApplicationServiceBase.generatePaymentLinkUrl,
      JSON.stringify({DAMSApplicationId: damsApplicationID, eMail: eMail}), {headers: header});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/application-service-base.ts